/**
 * Created by Administrator on 2018/5/18.
 */
import MD5 from "./md5.js"
import Service from "./allservice";
import jQuery from 'jquery'

var Common = {};

/**
 * 加载器实例
 */
//Common.Preloader = {
//  show : function()
//  {
//    var app = new Framework7();
//    app.showIndicator();
//  },
//
//  hidden : function()
//  {
//    var app = new Framework7();
//    app.hideIndicator();
//  }
//};

/**
 * URL参数实例
 */
Common.URL = {

  /**
   * 添加vm中的数据值
   * @param url 已存在的URL地址
   * @param vm vue实例对象
   * @param urlData 添加的URL参数
   * @returns {*}
   */
  appendURLData : function(url, vm, urlData)
  {
    if(!urlData)
    {
      return url;
    }
    for(var key in urlData)
    {
      var value = this.filterValue(urlData[key]);
      if(value)
      {
        url = this.appendURL(url, key, value);
      }
    }
    return url;
  },

  /**
   * 添加vm中的数据值
   * @param url 已存在的URL地址
   * @param vm vue实例对象
   * @param key vue实例对象key名称
   * @returns {*}
   */
  appendVmData : function(url, vm, key)
  {
    var value = this.getVmValue(key);
    if(value)
    {
      url = this.appendURL(url, key, value);
    }
    return url;
  },

  getUrlParm : function (name)
  {
    var regexS = "[\\?&]"+name+"=([^&#]*)" ;
    var regex = new RegExp( regexS ) ;
    var tmpURL = document.location.href ;
    var results = regex.exec( tmpURL ) ;
    if( results == null )
    {
      return "" ;
    }
    else
    {
      return results[1] ;
    }
  },

  /**
   * 取得服务器地址
   * @returns {string}
   */
  getServerUrl : function ()
  {
    var serverUrl = document.location.href;
    var firstPos = serverUrl.indexOf('/', 8);
    var secondPos = serverUrl.indexOf('/', firstPos+1);
    serverUrl = serverUrl.substring(0, secondPos);
    return serverUrl;
  },

  /**
   * 取得域名
   * @returns {string}
   */
  getServerDomain : function ()
  {
    var serverUrl = this.getServerUrl();
    var domain =  serverUrl.substring("http://".length, serverUrl.length);
    if(domain.indexOf("/") > 0)
    {
      domain = domain.substring(0, domain.indexOf("/"));
    }
    return domain;
  },

  /**
   * 过滤value值，如果是空，null,undefined等，自动转换为空字符''
   * @param value 需要过滤的值
   * @returns {*}
   */
  filterValue : function(value)
  {
    if(value == null || value == 'null' || value == undefined || value == 'undefined')
    {
      return '';
    }
    return value;
  },

  /**
   * 取得vue实例中data中的值
   */
  getVmValue : function(vm, key) {
    var value = vm.$data[key];
    vm.$data[key] = this.filterValue(value);
    return vm.$data[key];
  },

  /**
   * 追加URL参数
   * @param url 已存在的URL数据
   * @param key 追加参数的key名称
   * @param value 追加的值, 可以是数组，基本类型，JSON对象等
   * @returns {*}
   */
  appendURL : function(url, key, value)
  {
    if(!value)
    {
      value = "";
    }

    var values = [];
    if(jQuery.isArray(value))
    {
      values = value;
    }
    else
    {
      values.push(value);
    }

    for(var pos in values)
    {
      var urlKey = key;
      var urlValue = values[pos];

      var isJSONObj = typeof(urlValue) == "object" && Object.prototype.toString.call(urlValue).toLowerCase() == "[object object]" && !urlValue.length;
      if (isJSONObj)
      {
        for(var jsonKey in urlValue)
        {
          this.appendEncodeURL(url, jsonKey, urlValue[jsonKey]);
        }
        return url;
      }

      return this.appendEncodeURL(url, urlKey, urlValue);
    }
    return url;
  },

  /**
   * 追加URL参数键值
   * @param url 已存在的URL参数
   * @param urlKey 追加URL参数名
   * @param urlValue 追加URL参数值
   * @returns {*}
   */
  appendEncodeURL : function(url, urlKey, urlValue)
  {
    if(url.indexOf('?') > 0)
    {
      url = url + '&' + urlKey + '=' + encodeURIComponent(urlValue);
    }
    else
    {
      url = url + '?' + urlKey + '=' + encodeURIComponent(urlValue);
    }
    return url;
  },

  /**
   * 取得route的url地址
   */
  getF7RouteUrl : function()
  {
    var url = window.location.href;
    if(typeof(PROJECT_NAME) == 'undefined')
    {
      window.PROJECT_NAME = "mobile";
    }
    var devUrl = 'http://' + window.location.host;
    if (url.indexOf(PROJECT_NAME) >= 0) {
      devUrl = devUrl  + "/" + PROJECT_NAME;
    }
    var urlHref;
    if (url.indexOf(devUrl + '/#/?route=') >= 0) {
      urlHref = Common.regExp(url, devUrl + '/#/\\?route=');
    }
    else if (url.indexOf(devUrl + '/#') >= 0) {
      urlHref = Common.regExp(url, devUrl + '/#');
    }
    else {
      urlHref = Common.regExp(url, devUrl);
    }

    var paramUrl = "";
    var paramStartPos = urlHref.indexOf("?") >=0 ? urlHref.indexOf("?") : urlHref.indexOf("&");
    if(paramStartPos >= 0)
    {
      paramUrl = urlHref.substr(paramStartPos);
      urlHref = urlHref.substring(0, paramStartPos);
      if(paramUrl.indexOf("&") == 0 && paramUrl.indexOf("?") < 0)
      {
        paramUrl = paramUrl.replace("&", "?");
      }
    }

    if (urlHref == '/' || urlHref == '' || urlHref == PROJECT_NAME  || urlHref.indexOf('index.html') >= 0) {
      urlHref = '/home/'
    }
    console.log(paramUrl);
    return urlHref + paramUrl;
  },

  /**
   * 压入历史记录
   */
  pushHistoryState : function(route)
  {
    var url = window.location.href;
    if(typeof(PROJECT_NAME) == 'undefined')
    {
      window.PROJECT_NAME = "mobile";
    }
    var hrefAdd = '/#/?route=';
    if (url.indexOf(PROJECT_NAME) >= 0) {
      hrefAdd = '/' + PROJECT_NAME + '/#/?route='
    }
    hrefAdd = hrefAdd + route.path;
    if(route.query)
    {
      for(var key in route.query)
      {
        if(key == '' || key == 'route')
        {
          continue;
        }
        hrefAdd = Common.URL.appendURL(hrefAdd, key, route.query[key]);
      }
    }
    window.history.pushState('', '', hrefAdd);
  }
};

/**
 * Cookie常用实例
 */
Common.CookieOperator = {

  /**
   * 设置cookie值
   * @param name 名称
   * @param value 值
   * @param expires 过期时间， 默认30天
   * @param path 路径，默认当前路径
   * @param domain 域名，
   */
  setCookie : function(name, value, expires, path, domain)
  {
    var uexp = new Date().getTime() + (1000 * 60 * 60 * 24 * 30);
    var expdate = new Date();
    expdate.setTime(uexp);

    path = path ? path : '/';
    domain = domain ? domain : Common.URL.getServerDomain();
    expires = expires ? expires : expdate.toGMTString();

    document.cookie = name + "=" + escape (value)
      +(";expires="+ expires)
      + ("; path=" + path)
      +("; domain="+domain);
  },

  delCookie : function(name)
  {
    var exp = new Date();
    exp.setTime (exp.getTime() - 1);
    this.setCookie(name, "", exp);
  },

  getCookie : function(fname)
  {
    var name,value;
    var beginning,middle,end;

    beginning = 0;
    while(beginning < document.cookie.length)
    {
      middle = document.cookie.indexOf("=",beginning);
      end = document.cookie.indexOf(";",beginning);

      if(end == -1)
      {
        end = document.cookie.length;
      }
      if((middle > end) || (middle == -1))
      {
        name = document.cookie.substring(beginning,end);
        value = "";
      }
      else
      {
        name = document.cookie.substring(beginning,middle);
        value = document.cookie.substring(middle+1,end);
      }
      if(name == fname)
      {
        return unescape(value);
      }

      beginning = end + 2;
    }
  }
};

Common.Date = {
  /**
   * 取得当前时间字符串，格式为yyyy-MM-dd
   * @returns {string}
   */
  getCurrentDateStr : function()
  {
    var date = new Date();
    var year = date.getFullYear();
    var month = (date.getMonth() + 1);
    if(parseInt(month) < 10)
    {
      month = '0'+(date.getMonth() + 1)
    }
    var day = date.getDate();
    if(parseInt(day) < 10){
      day = '0'+date.getDate();
    }
    var currentDate = year + '-' + month +'-' + day;
    return currentDate;
  },

  /***
   * 获得当前时间
   */
  getCurrentDate: function () {
    var currentDate = new Date();
    return new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
  },

  /***
   * 获得指定日期的起始日期
   */
  getStartDate: function (date) {
    var startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    return startDate;
  },

  /***
   * 获得指定日期的结束日期
   */
  getEndDate: function (date) {
    var startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
    return startDate;
  },

  /***
   * 获得指定日期当天的起止日期
   */
  getStartEndDates: function (date) {
    var startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    var endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate()+1, 23, 59, 59);
    return [startDate, endDate];
  },

  /***
   * 获得当前日期的起止日期
   */
  getCurrentDates: function () {
    var currentDate = this.getCurrentDate();
    return this.getStartEndDates(currentDate);
  },

  /**
   * 取得昨天日期的起止日期
   */
  getYesterdayDates: function() {
    var currentDate = this.getCurrentDate();
    currentDate.setDate(currentDate.getDate()-1);
    return this.getStartEndDates(currentDate);
  },

  /***
   * 获得本周起止时间
   */
  getCurrentWeek: function () {
    //起止日期数组
    var startStop = new Array();
    //获取当前时间
    var currentDate = this.getCurrentDate();
    //返回date是一周中的某一天
    var week = currentDate.getDay();
    //返回date是一个月中的某一天
    var month = currentDate.getDate();

    //一天的毫秒数
    var millisecond = 1000 * 60 * 60 * 24;
    //减去的天数
    var minusDay = week != 0 ? week - 1 : 6;
    //alert(minusDay);
    //本周 周一
    var monday = new Date(currentDate.getTime() - (minusDay * millisecond));
    //本周 周日
    var sunday = new Date(monday.getTime() + (6 * millisecond));
    //添加本周时间
    startStop.push(this.getStartDate(monday)); //本周起始时间
    //添加本周最后一天时间
    startStop.push(this.getEndDate(sunday)); //本周终止时间
    //返回
    return startStop;
  },

  /***
   * 获得本月的起止时间
   */
  getCurrentMonth: function () {
    //起止日期数组
    var startStop = new Array();
    //获取当前时间
    var currentDate = this.getCurrentDate();
    //获得当前月份0-11
    var currentMonth = currentDate.getMonth();
    //获得当前年份4位年
    var currentYear = currentDate.getFullYear();
    //求出本月第一天
    var firstDay = new Date(currentYear, currentMonth, 1);


    //当为12月的时候年份需要加1
    //月份需要更新为0 也就是下一年的第一个月
    if (currentMonth == 11) {
      currentYear++;
      currentMonth = 0; //就为
    } else {
      //否则只是月份增加,以便求的下一月的第一天
      currentMonth++;
    }


    //一天的毫秒数
    var millisecond = 1000 * 60 * 60 * 24;
    //下月的第一天
    var nextMonthDayOne = new Date(currentYear, currentMonth, 1);
    //求出上月的最后一天
    var lastDay = new Date(nextMonthDayOne.getTime() - millisecond);

    //添加至数组中返回
    startStop.push(this.getStartDate(firstDay));
    startStop.push(this.getEndDate(lastDay));
    //返回
    return startStop;
  },

  /**
   * 得到本季度开始的月份
   * @param month 需要计算的月份
   ***/
  getQuarterSeasonStartMonth: function (month) {
    var quarterMonthStart = 0;
    var spring = 0; //春
    var summer = 3; //夏
    var fall = 6;   //秋
    var winter = 9; //冬
    //月份从0-11
    if (month < 3) {
      return spring;
    }

    if (month < 6) {
      return summer;
    }

    if (month < 9) {
      return fall;
    }

    return winter;
  },

  /**
   * 获得该月的天数
   * @param year年份
   * @param month月份
   * */
  getMonthDays: function (year, month) {
    //本月第一天 1-31
    var relativeDate = new Date(year, month, 1);
    //获得当前月份0-11
    var relativeMonth = relativeDate.getMonth();
    //获得当前年份4位年
    var relativeYear = relativeDate.getFullYear();

    //当为12月的时候年份需要加1
    //月份需要更新为0 也就是下一年的第一个月
    if (relativeMonth == 11) {
      relativeYear++;
      relativeMonth = 0;
    } else {
      //否则只是月份增加,以便求的下一月的第一天
      relativeMonth++;
    }
    //一天的毫秒数
    var millisecond = 1000 * 60 * 60 * 24;
    //下月的第一天
    var nextMonthDayOne = new Date(relativeYear, relativeMonth, 1);
    //返回得到上月的最后一天,也就是本月总天数
    return new Date(nextMonthDayOne.getTime() - millisecond).getDate();
  },

  /**
   * 获得本季度的起止日期
   */
  getCurrentSeason: function () {
    //起止日期数组
    var startStop = new Array();
    //获取当前时间
    var currentDate = this.getCurrentDate();
    //获得当前月份0-11
    var currentMonth = currentDate.getMonth();
    //获得当前年份4位年
    var currentYear = currentDate.getFullYear();
    //获得本季度开始月份
    var quarterSeasonStartMonth = this.getQuarterSeasonStartMonth(currentMonth);
    //获得本季度结束月份
    var quarterSeasonEndMonth = quarterSeasonStartMonth + 2;

    //获得本季度开始的日期
    var quarterSeasonStartDate = new Date(currentYear, quarterSeasonStartMonth, 1);
    //获得本季度结束的日期
    var quarterSeasonEndDate = new Date(currentYear, quarterSeasonEndMonth, this.getMonthDays(currentYear, quarterSeasonEndMonth));
    //加入数组返回
    startStop.push(this.getStartDate(quarterSeasonStartDate));
    startStop.push(this.getEndDate(quarterSeasonEndDate));
    //返回
    return startStop;
  },

  /***
   * 得到本年的起止日期
   *
   */
  getCurrentYear: function () {
    //起止日期数组
    var startStop = new Array();
    //获取当前时间
    var currentDate = this.getCurrentDate();
    //获得当前年份4位年
    var currentYear = currentDate.getFullYear();

    //本年第一天
    var currentYearFirstDate = new Date(currentYear, 0, 1);
    //本年最后一天
    var currentYearLastDate = new Date(currentYear, 11, 31);
    //添加至数组
    startStop.push(this.getStartDate(currentYearFirstDate));
    startStop.push(this.getEndDate(currentYearLastDate));
    //返回
    return startStop;
  },

  /**
   * 返回上一个月的第一天Date类型
   * @param year 年
   * @param month 月
   **/
  getPriorMonthFirstDay: function (year, month) {
    //年份为0代表,是本年的第一月,所以不能减
    if (month == 0) {
      month = 11; //月份为上年的最后月份
      year--; //年份减1
      return new Date(year, month, 1);
    }
    //否则,只减去月份
    month--;
    return new Date(year, month, 1);
  },

  /**
   * 获得上一月的起止日期
   * ***/
  getPreviousMonth: function () {
    //起止日期数组
    var startStop = new Array();
    //获取当前时间
    var currentDate = this.getCurrentDate();
    //获得当前月份0-11
    var currentMonth = currentDate.getMonth();
    //获得当前年份4位年
    var currentYear = currentDate.getFullYear();
    //获得上一个月的第一天
    var priorMonthFirstDay = this.getPriorMonthFirstDay(currentYear, currentMonth);
    //获得上一月的最后一天
    var priorMonthLastDay = new Date(priorMonthFirstDay.getFullYear(), priorMonthFirstDay.getMonth(), this.getMonthDays(priorMonthFirstDay.getFullYear(), priorMonthFirstDay.getMonth()));
    //添加至数组
    startStop.push(this.getStartDate(priorMonthFirstDay));
    startStop.push(this.getEndDate(priorMonthLastDay));
    //返回
    return startStop;
  },


  /**
   * 获得上一周的起止日期
   * **/
  getPreviousWeek: function () {
    //起止日期数组
    var startStop = new Array();
    //获取当前时间
    var currentDate = this.getCurrentDate();
    //返回date是一周中的某一天
    var week = currentDate.getDay();
    //返回date是一个月中的某一天
    var month = currentDate.getDate();
    //一天的毫秒数
    var millisecond = 1000 * 60 * 60 * 24;
    //减去的天数
    var minusDay = week != 0 ? week - 1 : 6;
    //获得当前周的第一天
    var currentWeekDayOne = new Date(currentDate.getTime() - (millisecond * minusDay));
    //上周最后一天即本周开始的前一天
    var priorWeekLastDay = new Date(currentWeekDayOne.getTime() - millisecond);
    //上周的第一天
    var priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (millisecond * 6));

    //添加至数组
    startStop.push(this.getStartDate(priorWeekFirstDay));
    startStop.push(this.getEndDate(priorWeekLastDay));

    return startStop;
  },

  /**
   * 得到上季度的起始日期
   * year 这个年应该是运算后得到的当前本季度的年份
   * month 这个应该是运算后得到的当前季度的开始月份
   * */
  getPriorSeasonFirstDay: function (year, month) {
    var spring = 0; //春
    var summer = 3; //夏
    var fall = 6;   //秋
    var winter = 9; //冬

    //月份从0-11
    if(month <= summer)
    {
      year--;
      month = winter;
    }
    else if(month <= summer)
    {
      month = spring;
    }
    else if(month <= fall)
    {
      month = summer;
    }
    else if(month <= winter)
    {
      month = fall;
    }
    else
    {
      month = winter;
    }
    return new Date(year, month, 1);
  },

  /**
   * 得到上季度的起止日期
   * **/
  getPreviousSeason: function () {
    //起止日期数组
    var startStop = new Array();
    //获取当前时间
    var currentDate = this.getCurrentDate();
    //获得当前月份0-11
    var currentMonth = currentDate.getMonth();
    //获得当前年份4位年
    var currentYear = currentDate.getFullYear();
    //上季度的第一天
    var priorSeasonFirstDay = this.getPriorSeasonFirstDay(currentYear, currentMonth);
    //上季度的最后一天
    var priorSeasonLastDay = new Date(priorSeasonFirstDay.getFullYear(), priorSeasonFirstDay.getMonth() + 2, this.getMonthDays(priorSeasonFirstDay.getFullYear(), priorSeasonFirstDay.getMonth() + 2));
    //添加至数组
    startStop.push(this.getStartDate(priorSeasonFirstDay));
    startStop.push(this.getEndDate(priorSeasonLastDay));
    return startStop;
  },

  /**
   * 得到去年的起止日期
   * **/
  getPreviousYear: function () {
    //起止日期数组
    var startStop = new Array();
    //获取当前时间
    var currentDate = this.getCurrentDate();
    //获得当前年份4位年
    var currentYear = currentDate.getFullYear();
    currentYear--;
    var priorYearFirstDay = new Date(currentYear, 0, 1);
    var priorYearLastDay = new Date(currentYear, 11, 1);
    //添加至数组
    startStop.push(this.getStartDate(priorYearFirstDay));
    startStop.push(this.getEndDate(priorYearLastDay));
    return startStop;
  },

  /**
   * 取得当前时间字符串形式 yyyy-MM-dd hh:mm:ss
   * @returns {string}
   */
  getDateFormat: function (date) {
    var seperator1 = "-";
    var seperator2 = ":";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
      + " " + date.getHours() + seperator2 + date.getMinutes()
      + seperator2 + date.getSeconds();
    return currentdate;
  },

  getDateFormatNoTime: function (date) {
    var seperator1 = "-";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = date.getFullYear()+seperator1+ month+seperator1+ strDate;
    return currentdate;
  },

  /**
   *  将字符串时间yyyy-MM-dd hh:mm:ss转换为时间对象
   * @param dataStr
   * @returns {Date}
   */
  convertStrToDate : function (dataStr) {
    var dt = new Date(dataStr.replace(/-/,"/"));
    return dt;
  },

  /**
   * 比较两个时间对象大小
   * @param date1
   * @param date2
   * @returns {number}
   */
  compareDate : function (date1, date2)
  {
    if(date1.getTime() > date2.getTime()) {
      return 1;
    } else if(date1.getTime() == date2.getTime()) {
      return 0;
    } else if(date1.getTime() < date2.getTime()) {
      return -1;
    }
  }
};

/**
 * 页面常用操作
 */
Common.PageOperator =
{
  /**
   * 展现提示信息
   * @param msg
   */
  //showPromptMsg : function(isError, message)
  //{
  //  var app = new Framework7();
  //  app.addNotification({
  //    "title" : isError ? "操作失败" : "操作成功",
  //    "message" : message,
  //    "media" : isError ? "<i class='iconfont icon-error'></i>" : "<i class='iconfont icon-success'></i>",
  //    "hold" : 5000,
  //    "button" : {"text" : "关闭",color:"#ff3366"},
  //    "additionalClass" : isError ? "message_error" : "message_success"
  //  });
  //},

  /**
   * 检查错误提示， 并重置提交按钮
   * @param vm vue实例对象
   * @param resultData 响应结果
   * @param disableBtnName 按钮禁用vm名称
   * @returns {boolean}
   */
  checkResultData : function(vm, resultData, disableBtnName)
  {
    if(!resultData.success)
    {
      // 599表示错误消息已处理 5005表示用户未登录
      if(resultData.code != 599 && resultData.code != 5005)
      {
        var errorMsg = resultData.error;
        if(typeof(errorMsg) == "object" && errorMsg[0].failedDesc && typeof(errorMsg[0].failedDesc) == "object")
        {
          errorMsg = errorMsg[0].failedDesc[0];
        }
        this.setPromptMsg($scope, errorMsg);
      }

      if(disableBtnName != null && disableBtnName != undefined && vm.$data[disableBtnName])
      {
        vm.$data[disableBtnName] = false;
      }
      return false;
    }

    return true;
  }
};

/**
 * 树实例操作
 */
Common.Tree = {
  /**
   * 取得所选择了的models
   * @param vm vue实例对象
   * @param modelListName 树节点数组集合键名称
   * @returns {Array}
   */
  getSelectModels : function(vm, modelListName)
  {
    var selectModels = new Array();
    for(var index in vm.$data[modelListName])
    {
      if(vm.$data[modelListName][index].checked)
      {
        selectModels.push(vm.$data[modelListName][index]);
      }
    }

    return selectModels;
  },

  /**
   * 全选操作
   * @param vm vue实例对象
   * @param modelListName 树节点数组集合键名称
   * @param selectAllName 全选多选按钮的绑定值
   */
  selectAll : function(vm, modelListName, selectAllName)
  {
    var leghth = vm.$data[modelListName].length;
    for (var i = 0; i < leghth; i++)
    {
      vm.$set(vm.$data[modelListName][i], 'checked', vm.$data[selectAllName]);
    }
  },

  /**
   * 获取树中选择的子节点
   * @param rootNode 根节点对象
   * @param onlyLastLevelChild 仅仅取得最后一个选择节点
   * @param allSelect 选择该路径上所有选择的节点名称
   * @returns {Array}
   */
  getSelectedTreeNodes : function(rootNode, onlyLastLevelChild, allSelect)
  {
    delete rootNode.nodeIdMap;
    rootNode.nodeIdMap = {};
    var hasChildSelected = function(node, selectedList, onlyLastChild, allSelect)
    {
      var hasChildSelect = false;
      var childNodes = node.childs;
      if(!childNodes)
      {
        return hasChildSelect;
      }

      for(var index = 0; index < childNodes.length; index++)
      {
        var childNode = childNodes[index];
        if(childNode.checked)
        {
          if(allSelect)
          {
            rootNode.nodeIdMap[childNode.parent+"@@"+childNode.id] = childNode;
            selectedList.push(childNode);
            hasChildSelected(childNode, selectedList, onlyLastChild, allSelect);
          }
          else
          {
            var isLastChild = childNode.level == treeLevel;
            if((onlyLastChild && (isLastChild || (childNode.childs && childNode.childs.length == 0)))
              || ((!onlyLastChild && !hasChildSelected(childNode, selectedList, onlyLastChild))))
            {
              rootNode.nodeIdMap[childNode.parent+"@@"+childNode.id] = childNode;
              selectedList.push(childNode);
            }
          }

          hasChildSelect = true;
        }
      }

      return hasChildSelect;
    };

    var selectedNodes = new Array();
    var treeLevel = rootNode.treeLevel;
    hasChildSelected(rootNode, selectedNodes, onlyLastLevelChild, allSelect);
    return selectedNodes;
  },

  /**
   * 初始化树节点
   * @param vm vue实体对象
   * @param initTreeNodes 初始化节点数据
   * @param initAppendName 节点附加名称
   */
  initTreeComponents : function(vm, initTreeNodes, initAppendName)
  {
    var rootNode = vm.$data.rootNode;
    if(rootNode && rootNode.initTreeFun)
    {
      rootNode.initTreeFun.call(vm, initTreeNodes, initAppendName);
    }
    else
    {
      setTimeout(function(){this.initTreeComponents(vm, initTreeNodes, initAppendName)}, 50);
    }
  }
};

/**
 * 请求操作实例
 */
Common.Request = {

  /**
   * 发送请求前，对URL的处理
   * @param vm vue实例对象
   * @param url 请求地址
   * @param urlData url参数
   * @returns {*}
   */
  beforeSend : function(vm, url, urlData)
  {
    if(!urlData)
    {
      urlData = {};
    }

    if (url.substring(0, 1) != '/')
    {
      url = "/" + url;
    }
    if (url.substring(url.length-url) == '/')
    {
      url = url.substring(url.length-1);
    }
    // 附加分页信息
    urlData = Common.PageData.beforeRequest(vm, urlData);
    urlData = Common.Permission.generateSignParam(url, urlData);
    url = Common.URL.appendURLData(url, vm, urlData);
    if(url.indexOf("/logout") > 0)
    {
      Common.Permission.deleteAppIdSecret();
    }
    return url;
  },

  /**
   * 接收请求后，对response的处理
   * @param vm vue实例对象
   * @param response 响应结果
   * @param url 请求地址
   * @param postData post内容对象
   * @returns {*}
   */
  afterResponse : function(vm, response, url, postData)
  {
    if(response == null)
    {
      return response;
    }
    if(typeof response.success === 'undefined')
    {
      var errorMsg = this.getResponseError(response);
      //Common.PageOperator.showPromptMsg(true, errorMsg);
      return "abort";
    }

    // 服务器代码内部运行错误、数据校验失败
    if(response.code == 3000)
    {
      var validatorMsgMap = response.error;
      if(!validatorMsgMap)
      {
        return result;
      }
      //Common.PageOperator.showPromptMsg(true, validatorMsgMap);
      return "abort";
    }

    if(response.code == 5001 || response.code == 5002 || response.code == 5004 || response.code == 5005)
    {
      Common.Permission.deleteAppIdSecret();
    }

    // 用户未登录
    if(response.code == 5005)
    {
      //Common.PageOperator.showPromptMsg(true, response.error);
      // var app = new Framework7();
      // app.loginScreen();
      return "abort";
    }

    // 包含错误信息
    if(!response.success)
    {
      if(typeof response.error === 'string')
      {
        //Common.PageOperator.showPromptMsg(true, response.error);
      }
      return "abort";
    }

    // 判断返回类型为ResultData类型，并且执行结果为成功时
    if(response.signle && response.dataList && response.dataList.length == 1)
    {
      var successMsg = response.dataList[0];
      if((typeof successMsg === 'string') && /[\u0391-\uFFE5]+/.test(successMsg))
      {
        //Common.PageOperator.showPromptMsg(false, successMsg);
      }
    }
    var data = Common.PageData.afterResponse(vm, response, url);
    if(url.indexOf("/currentPerson") > 0)
    {
      Common.Permission.setAppIdSecret(data.appId, data.appSecret);
    }

    return data;
  },

  getResponseError : function(response)
  {
    var errorMsg = (response==null?"无法连接服务器" : response);
    if(response != null)
    {
      /* var getContent = function(startStr, endStr) {
       var posStart = response.indexOf(startStr);
       if(posStart > 0){
       var posEnd = response.indexOf(endStr, posStart);
       if(posEnd > 0){
       var content = response.substring(posStart+startStr.length, posEnd);
       return content;
       }
       }
       return "";
       };
       var errorMsg = "错误标题：" + getContent("<body><h1>", "</h1>") + "\r\n"
       + "错误类型：" + getContent("<p><b>type</b>", "</p>").replace("<u>","") + "\r\n"
       + "错误消息：" + getContent("<b>message</b>", "</u>").replace("<u>","") + "\r\n"
       + "错误描述：" + getContent("<b>description</b>", "</u>").replace("<u>","") + "\r\n";*/
      var errorMsg = response.message;
    }
    return errorMsg;
  }
};

/**
 * 分页信息处理实例
 */
Common.PageData = {

  /**
   * 在发送请求之前，设置分页参数到URL中
   * @param vm vm对象
   * @param url url对象数据
   * @returns {*}
   */
  beforeRequest: function (vm, urlData)
  {
    urlData = this.appendParamToUrlParams(vm, urlData, 'currentPage');
    urlData = this.appendParamToUrlParams(vm, urlData, 'pageSize');
    urlData = this.appendParamToUrlParams(vm, urlData, 'totalRows');
    urlData = this.appendParamToUrlParams(vm, urlData, 'orderBy');
    urlData = this.appendParamToUrlParams(vm, urlData, 'orderType');
    return urlData;
  },

  /**
   * 取得分页信息
   * @param vm vue实例对象
   * @returns {{}|*}
   */
  getQueryPage : function(vm)
  {
    if (!vm.$data.pageInfo || vm.$data.pageInfo == '')
    {
      vm.$data.pageInfo = {};
      vm.$data.pageInfo.pageSize = 10;
    }
    var pageInfo = vm.$data.pageInfo;
    if(!pageInfo.initDataListFun)
    {
      pageInfo.initDataListFun = "initDataList";
    }
    if(!pageInfo.dataListName)
    {
      pageInfo.dataListName = "dataList";
    }
    if(!vm.$data[pageInfo.dataListName])
    {
      vm.$data[pageInfo.dataListName] = [];
    }
    return pageInfo;
  },

  /**
   * 追加分页查询参数
   * @param vm vue实例对象
   * @param paramUrl 分页参数拼接的URL地址
   * @param paramName 分页对象参数名称
   * @returns {*}
   */
  appendParamToUrlParams: function (vm, urlData, paramName)
  {
    var pageInfo = this.getQueryPage(vm);
    if (pageInfo[paramName] && pageInfo[paramName] != null)
    {
      urlData[paramName] = pageInfo[paramName];
    }
    return urlData;
  },

  /**
   * 请求结束后
   * @param vm vue实例对象
   * @param response 响应对象
   * @param url 请求url地址
   * @returns {*}
   */
  afterResponse : function (vm, response, url)
  {
    var queryPage = response.queryPage;
    if (!queryPage)
    {
      if(response.signle)
      {
        if(response.dataList.length > 0)
        {
          return response.dataList[0];
        }
        return null;
      }
      return response.dataList
    }

    var pageInfo = this.getQueryPage(vm);
    for(var paramKey in queryPage)
    {
      vm.$set(vm.$data.pageInfo, paramKey, queryPage[paramKey]);
    }

    // 判断是否符合分页设定，如果支持，那么就会支持加载更多及下拉刷新
    var isSupportPageData = pageInfo.initDataListFun && Common.Util.isFunction(vm[pageInfo.initDataListFun])
      && pageInfo.dataListName && Common.Util.isArray(vm[pageInfo.dataListName]);
    if (!isSupportPageData)
    {
      return response.dataList;
    }
    // 处理数据
    var dataList = response.dataList;
    var existList = Common.Util.clone(vm.$data[pageInfo.dataListName]);
    for(var index in dataList)
    {
      existList.push(dataList[index]);
    }

    var pageElement = vm.$route.options.pageElement;
    var pageContent = $(pageElement).find('.page-content');
    if (pageContent && pageContent.length > 0)
    {
      if(pageInfo.isRefreshing==true)
      {
        var app = new Framework7();
        app.pullToRefreshDone(pageContent);
        pageInfo.isRefreshing = false;
      }
      if(pageInfo.isLoadingMore==true)
      {
        pageInfo.isLoadingMore = false;
      }

      // 下拉刷新 , 滚屏加载更多
      this.pullToRefresh(vm, pageContent, pageInfo);
      this.scrollLoadsMore(vm, pageContent, pageInfo);
    }

    response.dataList = existList;
    return response.dataList;
  },

  /**
   * 下拉刷新
   * @param vm vue实例对象
   * @param pageInfo 分页信息
   */
  pullToRefresh : function(vm, pageContent, pageInfo)
  {
    if(!pageContent.hasClass("pull-to-refresh-content"))
    {
      pageContent.addClass("pull-to-refresh-content");
    }
    var refreshLayer = pageContent.find(".pull-to-refresh-layer");
    if(!refreshLayer || refreshLayer.length==0)
    {
      var refreshHtml = "<div class='pull-to-refresh-layer'>"
        + "<div class='preloader'></div>"
        + "<div class='pull-to-refresh-arrow'></div>"
        + "</div>";
      pageContent.prepend(refreshHtml);
    }

    if(pageInfo.hasInitRefresh==true)
    {
      return;
    }
    pageContent.on('refresh', function (e)
    {
      var pageInfo = Common.PageData.getQueryPage(vm);
      if(pageInfo.isRefreshing==true)
      {
        return;
      }
      Common.PageData.resetPageInfo4Page(vm);
      pageInfo.isRefreshing = true;
      if (pageInfo.initDataListFun && Common.Util.isFunction(vm[pageInfo.initDataListFun])) {
        vm[pageInfo.initDataListFun]();
      }
    });

    var app = new Framework7();
    app.initPullToRefresh(pageContent);
    pageInfo.hasInitRefresh = true
  },

  /**
   * 滚动加载更多数据
   * @param vm vue实例对象
   */
  scrollLoadsMore : function(vm, pageContent, pageInfo)
  {
    var checkResult = Common.PageData.checkScrollLoadsMore(vm, pageContent, pageInfo);
    if(!checkResult)
    {
      return;
    }
    if(!pageContent.hasClass("infinite-scroll"))
    {
      pageContent.addClass("infinite-scroll");
    }
    var infinitePreLoader = pageContent.find(".infinite-scroll-preloader");
    if(!infinitePreLoader || infinitePreLoader.length==0)
    {
      var loadMoreHtml = "<div class='infinite-scroll-preloader'>"
        + "<div class='preloader'></div>"
        + "</div>";
      pageContent.append(loadMoreHtml);
    }

    if(pageInfo.hasInitLoadMore==true)
    {
      return;
    }
    pageContent.on('infinite', function ()
    {
      var pageInfo = Common.PageData.getQueryPage(vm);
      if(pageInfo.isLoadingMore==true)
      {
        return;
      }
      pageInfo.isLoadingMore = true;
      Common.PageData.nextPage(vm);
    });
    //var app = new Framework7();
    //app.attachInfiniteScroll(pageContent);
    pageInfo.hasInitLoadMore = true
  },

  // 移除加载更多选项
  checkScrollLoadsMore: function(vm, pageContent, pageInfo)
  {
    // 还有更多数据，则允许继续加载
    if(pageInfo.hasNextPage)
    {
      return true;
    }

    // 移除监听滚动事件
    //pageContent.removeClass("infinite-scroll");
    //pageContent.find(".infinite-scroll-preloader").remove();
    //var app = new Framework7();
    //app.detachInfiniteScroll(pageContent);
    pageInfo.hasInitLoadMore = false;
    return false;
  },

  /**
   * 重置分页信息并重置排序信息，重第一页开始，安装默认排序
   * @param vm vue实例对象
   */
  resetPageInfo : function (vm)
  {
    var pageInfo = this.getQueryPage(vm);
    for(var paramKey in pageInfo)
    {
      if(paramKey == 'pageSize' || paramKey == 'initDataListFun' || paramKey == 'dataListName'
        || paramKey == 'hasInitRefresh' || paramKey == 'hasInitLoadMore')
      {
        continue
      }
      vm.$delete(pageInfo, paramKey);
    }
    vm.$data[pageInfo.dataListName] = [];
  },

  /**
   * 重置当前页码，重第一页开始，不重置排序信息
   * @param vm
   */
  resetPageInfo4Page : function (vm)
  {
    var pageInfo = this.getQueryPage(vm);
    for(var paramKey in pageInfo)
    {
      if(paramKey == 'pageSize' || paramKey == 'initDataListFun' || paramKey == 'dataListName'
        || paramKey == 'hasInitRefresh' || paramKey == 'hasInitLoadMore'
        || paramKey == 'orderBy' || paramKey == 'orderType')
      {
        continue
      }
      vm.$delete(pageInfo, paramKey);
    }
    vm.$data[pageInfo.currentPage] = 1;
    vm.$data[pageInfo.dataListName] = [];
  },

  /**
   * 下一页数据
   * @param vm vue实例对象
   */
  nextPage : function (vm)
  {
    var pageInfo = this.getQueryPage(vm);
    // 已经是最后一页了
    if(!pageInfo.hasNextPage)
    {
      Common.tipMessage('温馨提示', "没有更多了");
      return;
    }

    // 设置了下一页调用方法
    pageInfo.currentPage = pageInfo.currentPage+1;
    if(pageInfo.initDataListFun && Common.Util.isFunction(vm[pageInfo.initDataListFun]))
    {
      vm[pageInfo.initDataListFun]();
    }
  }
};

/**
 * 常用处理类
 */
Common.Util = {

  /**
   * 克隆对象
   * @param obj
   * @returns {*}
   */
  clone: function (obj)
  {
    if (typeof (obj) != 'object') {
      return obj;
    }

    var re = {};
    if (obj.constructor == Array) {
      re = [];
    }

    for (var i in obj) {
      if (obj[i] == null) {
        re[i] = null;
      }
      else {
        re[i] = this.clone(obj[i]);
      }
    }
    return re;
  },

  /**
   * 生成UUID值
   * @returns {string}
   */
  generateId: function ()
  {
    var date = new Date();
    var id = date.getTime() + (Math.random() + "").substring(2);
    return id;
  },

  /**
   * 判断是否为空对象
   * @param obj 需要判断的对象
   * @returns {boolean}
   */
  isEmpty : function (obj)
  {
    if (obj == '' || obj == null || obj == 'null'
      || typeof(obj) == undefined || obj == 'undefined') {
      return true;
    }
    else {
      return false;
    }
  },

  /**
   * 判断是否为数组
   * @param obj
   * @returns {boolean}
   */
  isArray : function(obj)
  {
    return Object.prototype.toString.call(obj) === '[object Array]';
  },

  /**
   * 判断是否是字符串
   * @param obj
   * @returns {boolean}
   */
  isString : function(obj)
  {
    return typeof obj === 'String';
  },


  /**
   * 判断是否未定义
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is undefined.
   */
  isUndefined: function (value)
  {
    return typeof value === 'undefined';
  },


  /**
   * 判断是否已定义
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is defined.
   */
  isDefined: function (value)
  {
    return typeof value !== 'undefined';
  },


  /**
   * 判断是否为对象
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is an `Object` but not `null`.
   */
  isObject :  function (value)
  {
    return value !== null && typeof value === 'object';
  },

  /**
   * 判断是否为数字
   * 包含特殊数字 `NaN`, `+Infinity` 和 `-Infinity`.
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Number`.
   */
  isNumber : function (value)
  {
    return typeof value === 'number';
  },

  /**
   * 判断是否为日期类型
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Date`.
   */
  isDate : function (value)
  {
    return Object.prototype.toString.call(value) === '[object Date]';
  },

  /**
   * 判断对象是否为方法
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Function`.
   */
  isFunction: function (value)
  {
    return typeof value === 'function';
  },

  /**
   * 判断是否为正则表达式
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `RegExp`.
   */
  isRegExp : function (value)
  {
    return Object.prototype.toString.call(value) === '[object RegExp]';
  },

  /**
   * 取得JSONObj的长度
   * @param data jsonObject对象
   * @returns {number} -1表示不存在，其他表示长度
   */
  getJsonObjectLength : function(data)
  {
    if(!data)
    {
      return -1;
    }

    var length = 0;
    for(var key in data)
    {
      length++;
    }
    return length;
  },

  /**
   * 弹出确认框
   * @param title 确认框标题
   * @param content 确认框内容
   * @param sureFun 点击确认后的回调
   * @param cancelFun 点击取消后的回调
   */
  //showConfirm : function (title, content, sureFun, cancelFun)
  //{
  //  var app = new Framework7();
  //  app.confirm(content, title, sureFun, cancelFun);
  //},

  /**
   * 弹出提示框
   * @param title 提示框标题
   * @param content 提示框内容
   * @param callBack 点击确认后的回调
   */
  //showAlert : function (title, content, callBack)
  //{
  //  var app = new Framework7();
  //  app.alert(content, title, callBack);
  //},

  /**
   * 判断是否为手机号码
   * @param value
   * @returns {boolean}
   */
  isMobile : function(value) {
    // 大陆
    // ^((\\+86\\-)?)1(3|5|7|8)\\d{9}$
    var mobileMainland=/^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
    // 香港
    // ^(\\+852\\-)(5|6|9)\\d{7}$
    var mobileHongKong=/^((\+852\-)(5|6|9)+\d{7})$/;
    // 澳门
    // ^(\\+853\\-)(6|8)\\d{7})$
    var mobileAomen=/^((\+853\-)(6|8)+\d{7})$/;
    // 台湾
    // ^(\\+886\\-)09\\d{8}$
    var mobileTaiwan=/^((\+886\-)(09)+\d{8})$/;
    return mobileMainland.test(value) || mobileHongKong.test(value) || mobileAomen.test(value) || mobileTaiwan.test(value);
  },

  getBooleanValue : function(value, defaultValue)
  {
    if(value == "false" || value == false)
    {
      return false;
    }
    if(value == "true" || value == true)
    {
      return true;
    }
    return defaultValue;
  },

  getStringValue : function(value, defaultValue)
  {
    if(value)
    {
      return value;
    }
    return defaultValue;
  },

  getIntValue : function(value, defaultValue)
  {
    if(value && jQuery.isNumber(value))
    {
      return value;
    }
    return defaultValue;
  },

  convertToBoolean : function (obj) {
    switch (obj) {
      case undefined:
      case null:
      case false:
      case "false":
      {
        return false;
      }
      case true:
      case "true":
      {
        return true;
      }
      default :
      {
        return false;
      }
    }
  }
};

/**
 * DOM操作方法
 */
Common.Dom = {

  /**
   * 设置该元素下所有模块只读
   * @param elemId 元素Id
   */
  setReadOnlyElement : function (elemId)
  {
    var elemTab = jQuery("#"+elemId);
    elemTab.find("input").each(function(elem){
      var nextElem = jQuery(this).nextSibling();
      if(!(nextElem && nextElem.hasClass("btn_search")))
      {
        jQuery(this).attr("disabled", "disabled");
        jQuery(this).attr("readonly", "readonly");
      }
    });
    elemTab.find("textarea").each(function(elem){
      jQuery(this).attr("disabled", "disabled");
      jQuery(this).attr("readonly", "readonly")
    });
    elemTab.find("select").each(function(elem){
      jQuery(this).attr("disabled", "disabled");
      jQuery(this).attr("readonly", "readonly");
    });
    elemTab.find("button").each(function(elem){
      if(!(jQuery(this).hasClass("btn_search")))
      {
        jQuery(this).attr("disabled", "disabled");
      }
    });
    elemTab.find("a").each(function(elem){
      jQuery(this).attr("href", "javascript:void(0)");
      jQuery(this).attr("readonly", "readonly");
      jQuery(this).attr("ng-click", "");
    });
  },

  /**
   * 设置FORM表单中输入控件必填时label后自动加*操作
   * @param elemId
   */
  setRequireLabelAndSameWidth : function (elemId)
  {
    var getParentFormGroup = function(elem, index)
    {
      if(index > 5)
      {
        return null;
      }
      var elemParent = elem.parent(".form-group, .form-row");
      if(elemParent.length > 0)
      {
        if(elemParent.find(".div_label_content").length > 0)
        {
          return null;
        }
        return elemParent;
      }
      else
      {
        return getParentFormGroup(elem.parent(), ++index);
      }
    };

    var setRequiredMark = function(elem)
    {
      var required = elem.attr("required");
      var label = null;
      var parentFromGroup = getParentFormGroup(elem, 0);
      if(parentFromGroup)
      {
        label =  parentFromGroup.children("label:first");
      }

      if(label && label.length > 0) {
        if(required) {
          label.prepend('<font color="red">*</font>');
        }
        var replaceHTML = '<div class="div_label_content">'
          + '<div class="div_label">' + label.html() + '</div>'
          + '</div>';
        label.replaceWith(replaceHTML);
      }
    };

    var elemTab = jQuery("#"+elemId);
    elemTab.find("form input").each(function(elem){
      setRequiredMark(jQuery(this));
    });
    elemTab.find("form textarea").each(function(elem){
      setRequiredMark(jQuery(this));
    });
    elemTab.find("form select").each(function(elem){
      setRequiredMark(jQuery(this));
    });
  },

  /**
   * 取得iframe中的document对象
   * @param frameElem
   * @returns {*}
   */
  getFrameDocument : function (frameElem)
  {
    var innerDoc = null;
    if(frameElem.contentWindow && frameElem.contentWindow.document)
    {
      innerDoc = frameElem.contentWindow.document;
    }
    else if(frameElem.contentDocument)
    {
      innerDoc = frameElem.contentDocument;
    }
    return innerDoc;
  },

  /**
   * iframe开始加载的时候
   * @param frameId
   */
  frameOnloadFun : function (frameElem)
  {
    var innerDoc = this.getFrameDocument(frameElem);
    if(innerDoc && innerDoc.body && innerDoc.body.clientHeight)
    {
      innerDoc.body.style.overflowX="hidden";
      var iframes = innerDoc.getElementsByTagName("iframe");
      if(iframes.length == 0)
      {
        frameElem.height=innerDoc.body.scrollHeight;
        return true;
      }
    }
  },

  /**
   * iframe完成加载的时候
   */
  frameOnReadyStateChangeFun : function (frameElem)
  {
    if(frameElem.readyState=="complete")
    {
      this.frameOnloadFun(frameElem);
    }
  },

  /**
   * 当分享页面中嵌套有iframe时，将该iframe自适应屏幕大小
   * @param frameElem
   * @returns {boolean}
   */
  shareFrameDisplayAdjust : function (frameElem)
  {
    var innerDoc = this.getFrameDocument(frameElem);
    if(!innerDoc || !innerDoc.body)
    {
      return false;
    }

    var iframes = innerDoc.getElementsByTagName("iframe");
    if(iframes.length == 0)
    {
      return false;
    }

    var hight = document.body.firstElementChild.clientHeight-50;
    var width = document.body.firstElementChild.clientWidth;
    innerDoc.body.style.margin = "0px";
    innerDoc.body.style.padding = "0px";
    innerDoc.body.style.height = "auto";
    innerDoc.body.firstElementChild.style.margin = "0px";
    innerDoc.body.firstElementChild.style.padding = "0px";

    $(frameElem).css("width", "100%");
    $(frameElem).css("height", hight);

    for(var pos = 0; pos < iframes.length; pos++)
    {
      var iframe = iframes[pos];
      iframe.style.width = "100%";
      iframe.style.height = hight;
    }
  },

  /**
   *重新载入frameId
   * @param frameId
   * @param src
   */
  frameReloadSrc : function (frameId, src)
  {
    var frameElem = $("#"+frameId)[0];
    if(frameElem.contentWindow)
    {
      frameElem.contentWindow.location.href = src + "?args=" + Common.Util.generateId();
    }
  }
};

/**
 * 温馨提示弹窗提醒
 * @param title
 * @param message
 */
//Common.tipMessage = function(title,message)
//{
//  var app = new Framework7();
//  app.addNotification({
//    "title" : title,
//    "message" : message,
//    "media" : "<i class='iconfont icon-success'></i>",
//    "hold" : 3000,
//    "button" : {"text" : "关闭",color:"#ff3366"},
//    "additionalClass" : "message_success"
//  });
//};

/**
 * 删除无限滚动的dom元素
 * @param vm
 */
Common.deleteInfinite = function(vm)
{
  if($('.page-content').hasClass('infinite-scroll')){
    $('.page-content').removeClass('infinite-scroll');
    $('.infinite-scroll-preloader').remove();
  }
};

/**
 * 截取字符串
 * @param str
 * @param pattern
 * @returns {void|string|XML|*}
 */
Common.regExp=function(str,pattern)
{
  //删除指定字符串
  var res = str.replace(new RegExp(pattern), "");
  return res;
};

Common.Permission =
{
  //** 用户登录，设置账户信息 *//*
  setAppIdSecret : function(appId, appSecret)
  {
    this.appId = appId;
    this.appSecret = appSecret;
    Common.CookieOperator.setCookie("liveMobileAppId", this.appId);
    Common.CookieOperator.setCookie("liveMobileAppSecret", this.appSecret);
  },

  //** 用户登出，清除账户信息 *//*
  deleteAppIdSecret : function ()
  {
    delete this.appId;
    delete this.appSecret;
    Common.CookieOperator.delCookie("liveMobileAppId");
    Common.CookieOperator.delCookie("liveMobileAppSecret");
  },

  /**
   * 取得当前人获取的appId和appSecret
   */
  getAppIdSecret : function()
  {
    if(this.appId && this.appSecret)
    {
      return [this.appId, this.appSecret];
    }
    var appId = Common.CookieOperator.getCookie("liveMobileAppId");
    var appSecret = Common.CookieOperator.getCookie("liveMobileAppSecret");
    if(appId && appSecret)
    {
      this.appId = appId;
      this.appSecret = appSecret;
      return [this.appId, this.appSecret];
    }
    return [null, null];
  },

  /**
   * 生成加密后的url参数集合
   * @param url 请求地址
   * @param urlParams 原来的参数集合
   * @returns {*}
   */
  generateSignParam : function(url, urlParams)
  {
    var appIdSecret = this.getAppIdSecret();
    var appId = appIdSecret[0];
    var appSecret = appIdSecret[1];
    if(appId && appSecret)
    {
      return this.signUrlParams(url, urlParams, appId, appSecret);
    }
    else
    {
      return urlParams;
    }
  },

  /**
   * 生成加密
   * @param url
   * @param urlParams
   * @param appId
   * @param appSecret
   * @returns {*}
   */
  signUrlParams : function (url, urlParams, appId, appSecret)
  {
    var urlParams = this.filterReqParamKey(url, urlParams);
    urlParams.appid = appId;
    urlParams.method = url;
    urlParams.timestamp = new Date().getTime();
    var paramKeys = new Array();
    for(var paramKey in urlParams)
    {
      paramKeys.push(paramKey);
    }
    paramKeys.sort();
    var signValue = appSecret;
    for(var pos in paramKeys)
    {
      var paramKey = paramKeys[pos];
      signValue = signValue + paramKey + urlParams[paramKey];
    }
    signValue = signValue + appSecret;
    signValue = MD5.hex_md5(signValue);
    urlParams.sign = signValue;
    delete urlParams.method;
    return urlParams;
  },

  /**
   * 判断参数名是否合法
   * @param method 请求方法名
   * @param urlParams 请求URL参数集合
   * @returns {*}
   */
  filterReqParamKey: function (method, urlParams)
  {
    var deleteKeys = new Array();
    if (urlParams == null || typeof(urlParams) == 'undefined') {
      urlParams = {};
    }
    if (urlParams) {
      for (var paramKey in urlParams) {
        var paramValue = urlParams[paramKey];
        if (paramValue == null || typeof(paramValue) == 'undefined') {
          deleteKeys.push(paramKey);
          continue;
        }
        if (paramKey == 'appid' || paramKey == 'method' || paramKey == 'timestamp' || paramKey == 'sign') {
          alert("请求方法" + method + "包含" + paramKey + "非法关键参数名，请联系管理员！");
          return null;
        }
      }
      if (deleteKeys.length > 0) {
        for (var pos in deleteKeys) {
          var deleteKey = deleteKeys[pos];
          delete urlParams[deleteKey];
        }
      }
    }
    return urlParams;
  },
};

/**
 * 时间戳 转化成时间格式
 * @param timestamp   时间戳为10位需*1000，时间戳为13位的话不需乘1000
 * @returns {string}  2018-04-16 14:59:31
 */
Common.timestampToTime = function (timestamp) {
  var date = new Date(timestamp),//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    Y = date.getFullYear() + '-',
    M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-',
    D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ',
    h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':',
    m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':',
    s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
  return Y+M+D+h+m+s;
};

/**
 * 删除字符串空格
 * ltrim：左
 * rtrim：右
 * alltrim：左右空格
 */
Common.removeSpace = {
  ltrim : function (str) {
    return str.replace(/(^\s*)/g, "");
  },
  rtrim : function (str) {
    return str.replace(/(\s*$)/g, "");
  },
  alltrim : function (str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
};

/**
 * 根据时间戳转化成显示时间
 *      12：25（当天） 昨天 12：05（昨天） 5-6 12：03（当年） 2015-5-6 12：03（以前年）
 * @param timeStamp  13位时间戳
 * @returns {string}
 */
Common.showTimeByTimestamp = function (timeStamp)
{
  var nowTimeDate = new Date(),
    nowTimeStamp = nowTimeDate.getTime()/1000,
    showTimeDate = new Date(timeStamp),
    showTimeStamp = timeStamp/1000,
    different = nowTimeStamp - showTimeStamp,
    minutes = showTimeDate.getMinutes()<10 ? '0'+showTimeDate.getMinutes() : showTimeDate.getMinutes();

  if (different < 60*60*24*2 && (nowTimeDate.getDate()-showTimeDate.getDate()<2)){
    if (nowTimeDate.getDate()==showTimeDate.getDate()){
      return showTimeDate.getHours()+':'+minutes;
    }else {
      return '昨天 ' +showTimeDate.getHours()+':'+minutes;
    }
  }else if (nowTimeDate.getFullYear() == showTimeDate.getFullYear()){
    return (showTimeDate.getMonth()+1)+'-'+showTimeDate.getDate()+' '+showTimeDate.getHours()+':'+minutes;
  }else{
    return showTimeDate.getFullYear()+'-'+(showTimeDate.getMonth()+1)+'-'+showTimeDate.getDate()+' '+showTimeDate.getHours()+':'+minutes;
  }
};

/**
 * 获取用户个人信息
 * @param doSomething
 */
Common.getPersonUserInfo = function (self,doSomething) {
  Service.get(self,'contact/currentPerson').then(function (currentData){
    window.currentUser = currentData;
    if (doSomething){
      doSomething(self,currentData.personId);
    }
  });

};

/**
 * 同学会 外部链接跳转管理者
 * @type {{
 * pushParam: Common.webPagePushManager.pushParam,   跳转截取链接的不同部分，传参到跳转页面
 * showHtml: Common.webPagePushManager.showHtml      将传过来的参数拼接成Html 展示
 * }}
 */
Common.webPagePushManager = {
  pushParam: function (html) {
    var webfoot = html.split('aliyuncs.com/')[1];
    var param = webfoot.split('.')[0];
    return param;
  },
  showHtml:function (pushParam) {
    var webHead = 'http://bosum-official-website-test.oss-cn-shenzhen.aliyuncs.com/';
    return webHead + pushParam + '.html';
  }
};


export default Common;



// WEBPACK FOOTER //
// ./src/js/appCommon.js